import script from "./DisableAdditionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisableAdditionModal.vue?vue&type=script&lang=ts&setup=true"

import "./DisableAdditionModal.vue?vue&type=style&index=0&id=ff7da518&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff7da518"]])

export default __exports__